import { getStore } from "@/utils/storage";

const userInfo = getStore('userInfo', true);
export default {
    userInfo: userInfo,
}


// WEBPACK FOOTER //
// ./src/store/state.js